import AgCustomList from '@/pages/customManage/agCustomList'

export default [
  {
    path: '/agCustomList',
    name: 'AgCustomList',
    component: AgCustomList,
    meta: { name: '客户列表' }
  }
]



// WEBPACK FOOTER //
// ./src/router/customManage/agCustomList.js